export const environment = {
  production: false,
  apiUrl:'https://ecitation.sg.wisdoj.gov/ws',
  appBaseHref: '/',
  useClassicEngine: false,  
  accessibilityLink:'https://www.wisdoj.gov/Pages/AboutUs/website-accessibility-policy.aspx'
};
